import {css} from "@emotion/css";

import React from "react";
import PropTypes from "prop-types";
import {Alert, AlertTitle} from "@material-ui/lab";

const DeleteConfirmDialog = (
    {
        doDelete,
        closeDialog,
        title = " آیا از حذف این آیتم اطمینان دارید ؟!",
        description = "با اتمام حذف امکان بازیابی آن وجود نخواهد داشت !!!",
        submitTitle="حذف کن"
    }) => {
    return (
        <section className={css`display: flex;
          flex-direction: column;
          padding: 0 16px 16px 16px;
          overflow-x: hidden !important;
        `}>

            <div className="deleteDialogContainer">

                <Alert severity="warning" className={`warning-alert`}>
                    <AlertTitle>{title}</AlertTitle>
                    <div className={css`display: flex;
                      flex-direction: column;
                      gap: 8px;
                      margin-top: 16px;
                    `}>
                        {description}
                    </div>
                </Alert>

            </div>

            <div className="d-flex flex-column w-100">

                <div className={css`display: flex;
                  flex-direction: row;
                  flex-wrap: nowrap;
                  gap: .5rem;
                  margin-top: 1rem;
                `}>
                    <button onClick={doDelete} className={"btn-secondary flex-grow-1"}>{submitTitle}</button>
                    <button onClick={closeDialog} className={"btn-confirm flex-grow-1"}>بیخیال</button>
                </div>
            </div>
        </section>
    )
}


export default DeleteConfirmDialog;

DeleteConfirmDialog.propTypes = {
    doDelete: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
}